<template>
  <div>
    <el-form-item
      :label=" $t('边框宽度')"
    >
      <el-input-number
        v-model="config.borderWidth"
        controls-position="right"
        :placeholder="$t('请输入')"
        :min="0"
      ></el-input-number>
    </el-form-item>
    <el-form-item
      :label=" $t('边框颜色')"
    >
      <l-input-color
        v-model="config.borderColor"
        :placeholder="$t('请输入')"
      />
    </el-form-item>
    <el-form-item :label="$t('自定义类')">
      <el-input v-model="config.myclass"></el-input>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: "table-layout",
  inject: ["formDesign"],
  props: ["data"],
  data() {
    return {
    };
  },
  computed: {
    config() {
      return this.data;
    }
  },
  methods: {},
};
</script>
